module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 212);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

module.exports = require("prop-types");

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = require("classnames");

/***/ }),

/***/ 212:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _MessageBlock = __webpack_require__(213);

var _MessageBlock2 = _interopRequireDefault(_MessageBlock);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _MessageBlock2.default;

/***/ }),

/***/ 213:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = MessageBlock;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _general = __webpack_require__(214);

var _general2 = _interopRequireDefault(_general);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var typeClasses = {
  error: 'bg-negative',
  success: 'bg-positive'
};

/**
 * Error and success message blocks to be used as feedback on forms and other
 * places requiring user input. Set the style with the optional `type` prop.
 */
function MessageBlock(_ref) {
  var _cx;

  var children = _ref.children,
      fullWidth = _ref.fullWidth,
      isDisabled = _ref.isDisabled,
      textAlign = _ref.textAlign,
      type = _ref.type;

  var containerClasses = (0, _classnames2.default)(_general2.default.block, 'textAlign-' + textAlign, (_cx = {}, _defineProperty(_cx, typeClasses[type], !isDisabled), _defineProperty(_cx, 'bg-smoke--xd', isDisabled), _defineProperty(_cx, 'width-100', fullWidth), _cx));

  return _react2.default.createElement(
    'div',
    { className: containerClasses },
    children
  );
}

MessageBlock.propTypes = {
  children: _propTypes2.default.node.isRequired,
  fullWidth: _propTypes2.default.bool,
  isDisabled: _propTypes2.default.bool,
  textAlign: _propTypes2.default.oneOf(['left', 'right,', 'center']),
  type: _propTypes2.default.oneOf(Object.keys(typeClasses)).isRequired
};

MessageBlock.defaultProps = {
  fullWidth: false,
  textAlign: 'center',
  type: 'medium'
};

/***/ }),

/***/ 214:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"block":"general__block___1-5wx borderRadius-m c-white display-inlineBlock fontSize-m lineHeight-copy paddingLeftRight-m paddingTopBottom-s"};

/***/ })

/******/ });
//# sourceMappingURL=marvel-ui-message-block.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@marvelapp/marvel-ui/lib/marvel-ui-message-block.js
// module id = 1109
// module chunks = 168707334958949